export default {
  props: {
    formKey: String,
    config: Object,
  },
  methods: {
    onClick() {
      if(typeof this.config.callback != 'function') return
      this.config.callback(window.eagleLodash.cloneDeep(this.formInfo))
    },
  },
  computed: {
    create() {
      if(typeof this.config.create != 'function') return true
      return this.config.create(this.formInfo)
    },
    formApi() {
      return this.$store.getters[`form/${this.formKey}/api`]
    },
    formInfo() {
      return this.$store.getters[`form/${this.formKey}/info`]
    },
    label() {
      if(typeof this.config.label === 'function') {
        return this.config.label(this.formInfo)
      }

      return this.config.label || null
    },
    route() {
      if(typeof this.config.route === 'function') {
        return this.config.route(this.formInfo)
      }

      return null
    },
    href() {
      if(typeof this.config.href === 'function') {
        return this.config.href(this.formInfo)
      }

      return null
    },
    icon() {
      if(typeof this.config.icon === 'function') {
        return this.config.icon(this.formInfo)
      }

      if(this.config.icon) return this.config.icon

      return null
    },
    color() {
      if(typeof this.config.color === 'function') {
        return this.config.color(this.formInfo)
      }

      if(this.config.color) return this.config.color

      return 'primary'
    },
    linkTarget() {
      if(this.config.linkTarget === undefined) return '_blank'
      return this.config.linkTarget || '_blank'
    },
    buttonProperties() {
      if(typeof this.config.buttonProperties === 'function') {
        return this.config.buttonProperties(this.formInfo)
      }

      return null
    },
    small() {
      return this.config.small != false
    },
  },
}
